<template>
  <div class="otb-summary__personal-detail-container">
    <div class="wb-grid-row">
      <div
        class="wb-grid-col-mq1-12 wb-grid-col-mq3-9 wb-grid-col-offset-mq3-1"
      >
        <h3 class="otb-summary__personal-title" :class="personalTitleClass">
          {{ $t('summary.personalDetails.label') }}
        </h3>
      </div>
    </div>
    <div class="wb-grid-row">
      <div
        class="wb-grid-col-mq1-12 wb-grid-col-mq3-4 wb-grid-col-offset-mq3-1"
      >
        <div
          class="otb-summary__personal-detail otb-summary__personal-detail--mobile-name"
        >
          <p class="wb-type-copy">{{ name }}</p>
        </div>
        <div class="otb-summary__personal-detail" v-if="showCompanyDetails">
          <wb-icon
            class="otb-summary__personal-icon--location"
            name="company/24"
          ></wb-icon>
          <p class="wb-type-copy" v-if="customer.companyName">
            {{ customer.companyName }}
          </p>
          <p class="wb-type-copy" v-if="customer.vatNumber">
            {{ $t('summary.info.vat') }}
            <br />
            {{ customer.vatNumber }}
          </p>
        </div>
        <div
          class="otb-summary__personal-detail wb-margin-bottom-xxs"
          v-if="hasAddress"
        >
          <wb-icon
            class="otb-summary__personal-icon--location"
            name="bds/location/24"
          ></wb-icon>
          <p class="wb-type-copy">{{ address }}</p>
        </div>
      </div>
      <div
        class="wb-grid-col-mq1-12 wb-grid-col-mq3-4 wb-grid-col-offset-mq3-1"
      >
        <div class="otb-summary__personal-detail" v-if="hasDriverLicense">
          <wb-icon
            class="otb-summary__personal-icon--brochures"
            name="brochures"
          ></wb-icon>
          <p class="wb-type-copy">{{ customer.driverLicense }}</p>
        </div>
        <div class="otb-summary__personal-detail" v-if="hasPhone">
          <wb-icon
            class="otb-summary__personal-icon--call"
            name="bds/call/24"
          ></wb-icon>
          <p class="wb-type-copy">{{ customer.contacts.phone }}</p>
        </div>
        <div class="otb-summary__personal-detail" v-if="hasEmail">
          <wb-icon
            class="otb-summary__personal-icon--mail"
            name="bds/mail/24"
          ></wb-icon>
          <p class="wb-type-copy">{{ customer.contacts.email }}</p>
        </div>
      </div>
    </div>
    <div class="wb-grid-row" v-if="hasAppointmentMessage">
      <div
        class="wb-grid-col-mq1-12 wb-grid-col-mq3-10 wb-grid-col-offset-mq3-1"
      >
        <h4
          class="otb-summary__personal-aditional-title"
          :class="personalAditionalTitle"
        >
          {{ $t('summary.additionalInfo.label') }}
        </h4>
        <p class="wb-type-copy">
          {{ personalDetails.appointmentMessage }}
        </p>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';

import { useProspect } from '@dh-io-otb/shared/src/composables/prospect.composable';
import { useMediaQuery } from '../../../../composables/media-query.composable';

export default defineComponent({
  name: 'otb-summary-personal-details',
  props: {
    personalDetails: Object as () => any,
  },
  setup(props) {
    const { buildProspectAddress, buildProspectName } = useProspect();

    const { isMobile } = useMediaQuery();

    const address = computed(() => {
      const address = props.personalDetails?.customer?.address;
      if (!address?.city && !address?.street && !address?.postalCode) return;
      return buildProspectAddress({
        ...address,
        postCode: address.postalCode,
      });
    });

    const name = computed(() =>
      buildProspectName(props.personalDetails?.customer)
    );

    const showCompanyDetails = computed(
      () =>
        props.personalDetails?.customer?.companyName ||
        props.personalDetails?.customer?.vatNumber
    );
    const customer = computed(() => props.personalDetails?.customer);

    const hasAddress = computed(() => {
      return address.value && !!(address.value as string).trim();
    });

    const hasDriverLicense = computed(() => {
      return customer.value && customer.value.driverLicense;
    });

    const hasPhone = computed(() => {
      return (
        customer.value &&
        customer.value.contacts &&
        customer.value.contacts.phone
      );
    });

    const hasEmail = computed(() => {
      return (
        customer.value &&
        customer.value.contacts &&
        customer.value.contacts.email
      );
    });

    const hasAppointmentMessage = computed(() => {
      return props.personalDetails && props.personalDetails.appointmentMessage;
    });

    const personalTitleClass = computed(() => {
      return isMobile.value ? 'wb-type-copy-strong' : 'wb-type-heading-s';
    });

    const personalAditionalTitle = computed(() => {
      return isMobile.value ? 'wb-type-label' : 'wb-type-copy-strong';
    });

    return {
      address,
      customer,
      name,
      showCompanyDetails,
      hasAddress,
      hasDriverLicense,
      hasPhone,
      hasEmail,
      hasAppointmentMessage,
      personalTitleClass,
      personalAditionalTitle,
    };
  },
});
</script>
<style lang="scss" src="./summary-personal-details.scss"></style>
